import { tokens } from '@hotjar/hotsauce';

/**
 * Default feedback widget data.
 */
angular.module('hjFeedbackModule').service('DefaultFeedbackData', [
    function () {
        this.getData = function (existingWidgetCount, commentFooterEnabled) {
            return {
                connect_visit_data: 'always',
                show_legal: false,
                auto_screenshot: true,
                background: tokens.BRAND_COLORS.ember_700,
                content: {
                    initial: 'Help us improve by sharing your feedback.',
                    thankyou: 'Thank you for sharing your feedback with us!',
                    emotion: 'How would you rate your experience?',
                    email: "We may wish to follow up. Enter your email if you're happy for us to contact you.",
                    comment_footer: commentFooterEnabled
                        ? `<p><strong>Heads up! This is for feedback only.</strong></p>
                           <p>Need help? Contact us via our [link to Help Center].</p>`
                        : undefined
                },
                display_condition: 'immediate', // One of 'immediate', 'delay', 'abandon' or 'scroll'.
                display_delay: 0,
                display_type: 'button',
                enabled: false,
                emotion_style: 'default',
                forwarding_email_address_list: [],
                language: 'en',
                name: existingWidgetCount && existingWidgetCount >= 1 ? null : 'Feedback',
                description: null,
                persist_condition: 'always', // One of 'response', 'once' or 'always'.
                position: 'middle_right',
                show_branding: true,
                skin: 'light', // This is used to determine the face features' color.
                targeting_percentage: 100,
                targeting: [
                    {
                        component: 'device',
                        match_operation: 'exact',
                        negate: false,
                        pattern: 'desktop'
                    },
                    {
                        component: 'device',
                        match_operation: 'exact',
                        negate: false,
                        pattern: 'tablet'
                    },
                    {
                        component: 'device',
                        match_operation: 'exact',
                        negate: false,
                        pattern: 'phone'
                    }
                ],
                widget_label: null
            };
        };
    }
]);
